module.exports = __webpack_public_path__ + "static/img/logoV.bbba3558.png";